import { Button } from "@renderbus/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CountdownButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const [remainingTime, setRemainingTime] = useState(60);
  const [isCountingDown, setIsCountingDown] = useState(false);
  const { t } = useTranslation("profile");
  const startCountdown = () => {
    onClick?.();
    setIsCountingDown(true);
    setRemainingTime(60);

    const countdownInterval = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(countdownInterval);
      setIsCountingDown(false);
    }, 60000);
  };

  useEffect(() => {
    if (isCountingDown && remainingTime > 0) {
      const countdownTimeout = setTimeout(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);

      return () => {
        clearTimeout(countdownTimeout);
      };
    }
  }, [isCountingDown, remainingTime]);

  return (
    <Button
      onClick={startCountdown}
      disabled={isCountingDown}
      style={{ minWidth: 102 }}
    >
      {isCountingDown
        ? `${remainingTime}`
        : t("user_sign_out_get_validate_code")}
    </Button>
  );
};
export default CountdownButton;
